import React from "react";
import ValidatedNewPasswordForm from "../../components/ValidatedNewPasswordForm";
import { compose, graphql, Query } from "react-apollo";
import {
  login,
  updatePassword
} from "../../../api/queries/utilisateur.mutations";
import { notify } from "../../generic";
import { useAuthDispatch, useAuthState } from "../../Context";
import { useNavigate } from "react-router-dom";
import { getUtilisateur } from "../../../api/queries/utilisateur.queries";
import Loader from "../../components/Loader";

function SecuriteCompte(props) {
  const dispatch = useAuthDispatch();
  const navigate = useNavigate();
  const authContext = useAuthState(); //read user de

  const { userDetails = {} } = authContext;
  const { id: utilisateurId, login, email, token } = userDetails;

  const _mutateLoginUser = async ({
    email,
    newPassword: password,
    validationToken
  }) => {
    try {
      return props
        .login({
          variables: {
            email,
            password
          }
        })
        .then(({ data }) => {
          const { type, message, details } = data.login;

          if (type === "success") {
            dispatch({ type: "REQUEST_LOGIN" });
            const { user } = JSON.parse(details);

            if (user.token) {
              dispatch({ type: "LOGIN_SUCCESS", payload: user });
              localStorage.setItem("currentUser", JSON.stringify(user));

              //     navigate(`/mon-compte`);
            }
          } else {
            notify("error", message);
            dispatch({ type: "LOGIN_ERROR", error: message });
          }
        });

      return;
    } catch (error) {
      console.log(error);
      notify("error", error.message);
      dispatch({ type: "LOGIN_ERROR", error: error });
    }
  };

  const _mutateUpdatePassword = async ({ id, oldPassword, newPassword }) => {
    try {
      return props
        .updatePassword({
          variables: {
            id,
            oldPassword,
            newPassword
          }
        })
        .then(({ data }) => {
          const { type, message, details } = data.updatePassword;

          if (type === "success") {
            notify("success", message);
            return _mutateLoginUser({ email, newPassword });
          } else {
            notify("error", message);
          }
        });
    } catch (error) {
      console.log(error);
      notify("error", error.message);
      dispatch({ type: "LOGIN_ERROR", error: error });
    }
  };

  const handleUpdatePassword = async settings => {
    try {
      let response = await _mutateUpdatePassword({
        id: utilisateurId,
        ...settings
      }); //loginUser action makes the request and handles all the neccessary state changes

      //  navigate("/mon-compte/");
    } catch (error) {
      notify("error", error.message);
    }
  };

  return (
    <div>
      {" "}
      <h1 className="dashboardTitle pushed">Sécurité</h1>
      <div className="row pushedByMenu">
        <div className="col-md-12">
          <h3>Changement de mot de passe</h3>
        </div>
        <div className="pushedContainer">
          <ValidatedNewPasswordForm handleSubmit={handleUpdatePassword} />
        </div>
      </div>
    </div>
  );
}

export default compose(
  graphql(updatePassword, {
    name: "updatePassword"
  }),
  graphql(login, {
    name: "login"
  })
)(SecuriteCompte);
